const GroupingResult = {
  BETA_ATTRIBUTES: 'BETA_ATTRIBUTES',
  BETA_ATTRIBUTES_BUCKET: 'BETA_ATTRIBUTES_BUCKET',
  SECURITY_LEVEL_ATTRIBUTES: 'SECURITY_LEVEL_ATTRIBUTES', //faa data
  SECURITY_LEVEL_ATTRIBUTES_BUCKET: 'SECURITY_LEVEL_ATTRIBUTES_BUCKET', //weighted avg faa data
  SCENARIOS: 'SCENARIOS'
};

export default GroupingResult;
